export default __webpack_public_path__ + "static/realWorldImg4-d2c692adb54908813a3057b168331a5b.webp";